import { monthKeyToEndDate, monthKeyToStartDate, periodHeaderToMonthKey } from '../../../../utils/dateUtils';
import { AGGREGATED_ACCOUNT_ID } from './cfbAccountFilter';

interface OverviewAccount {
    accountId: string;
    name?: string;
    accountNumber?: string | number | null;
}

interface SummaryAccount {
    bankName: string;
    accountNumber?: string | number | null;
}

/** Account ids to query: every real account on Aggregated, else the one whose account number is the viewed id. */
export function resolveRowTransactionsAccountIds(viewedAccountId: string | undefined, bankingOverview: OverviewAccount[]): string[] {
    const realAccounts = bankingOverview.filter((account) => account.accountId !== AGGREGATED_ACCOUNT_ID);
    if (viewedAccountId?.toLowerCase() === AGGREGATED_ACCOUNT_ID.toLowerCase()) {
        return [...new Set(realAccounts.map((account) => account.accountId))];
    }
    const viewed = realAccounts.find((account) => account.accountNumber != null && String(account.accountNumber) === viewedAccountId);
    return viewed ? [viewed.accountId] : [];
}

/** The applied Time Period, else the span of the table's period headers; null when neither exists. */
export function resolveRowTransactionsWindow(
    rangeApplied: boolean,
    applied: { startDate: string; endDate: string },
    headers: { key: string; name: string }[] | undefined,
): { startDate: string; endDate: string } | null {
    if (rangeApplied) return applied;
    const monthKeys = (headers ?? [])
        .map((header) => periodHeaderToMonthKey(header.name))
        .filter(Boolean)
        .sort();
    if (monthKeys.length === 0) return null;
    return { startDate: monthKeyToStartDate(monthKeys[0]), endDate: monthKeyToEndDate(monthKeys[monthKeys.length - 1]) };
}

/** accountId -> "Bank: number" label; falls back to the overview name, and omits accounts with neither. */
export function buildAccountLabelById(bankingOverview: OverviewAccount[], summaryData: SummaryAccount[]): Record<string, string> {
    const labels: Record<string, string> = {};
    bankingOverview.forEach((account) => {
        const summary =
            account.accountNumber != null ? summaryData.find((s) => String(s.accountNumber) === String(account.accountNumber)) : undefined;
        const label = summary ? `${summary.bankName}: ${summary.accountNumber}` : account.name;
        if (label) labels[account.accountId] = label;
    });
    return labels;
}
